import { render, staticRenderFns } from "./add-activity.vue?vue&type=template&id=67de881d&scoped=true&"
import script from "./add-activity.vue?vue&type=script&lang=js&"
export * from "./add-activity.vue?vue&type=script&lang=js&"
import style0 from "./add-activity.vue?vue&type=style&index=0&id=67de881d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de881d",
  null
  
)

export default component.exports